var numeral = require('numeral')
/**
 * 金额加货币符号并四舍五入
 * @param {*} value
 * @param {*} Digits
 */
let currencyAndToFixed = (value, Digits) => {
  return '￥' + value.toFixed(Digits)
}
/**
 * 四舍五入
 * @param {*} value 数值类型
 * @param {*} Digits 小数点后几位
 */
let toFixed = (value, Digits) => {
  return value.toFixed(Digits)
}
// 金额加货币符号
let currency = value => {
  return '￥' + value
}
/**
 * 金额格式化
 * @param {} value  当前值
 * @param {*} format 默认格式  '0,0.00'
 */
let money = (value, format = '0,0.00') => {
  return numeral(value).format(format)
}
/**
 * 带币种符号   金额格式化
 * @param {} value
 * @param {*} format 默认格式  '0,0.00'
 */
let currMoney = (value, format = '0,0.00') => {
  return '￥' + numeral(value).format(format)
}
/**
 *  +
 * @param {*} val1
 * @param {*} val2
 */
let add = (val1, val2) => {
  var number1 = numeral(val1)
  var number2 = numeral(val2)
  return number1.add(number2.value()).value()
}
/**
 * -
 * @param {} val1
 * @param {*} val2
 */
let subtract = (val1, val2) => {
  // 减 -
  var number1 = numeral(val1)
  var number2 = numeral(val2)
  return number1.subtract(number2.value()).value()
}
let multiply = (val1, val2) => {
  // 乘 *
  var number1 = numeral(val1)
  var number2 = numeral(val2)
  return number1.multiply(number2.value()).value()
}
let divide = (val1, val2) => {
  // 除 /
  var number1 = numeral(val1)
  var number2 = numeral(val2)
  return number1.divide(number2.value()).value()
}
let omitShow = (str, n = 15) => {
  if (str == null) {
    return str
  }
  if (str.length > n) {
    str = str.substring(0, n) + '...'
  }
  return str
}

export {
  currency,
  money,
  currMoney,
  add,
  subtract,
  multiply,
  divide,
  currencyAndToFixed,
  toFixed,
  omitShow
}



// WEBPACK FOOTER //
// ./src/api/filter/custom.js